module.exports = __webpack_public_path__ + "tea_box_mockup_packagig_design_mint_tea_moc_bilja_josif_pancic.jpg?a6be82c27f5f5d05f87658bbe00396b1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/josif_pancic/tea_box_mockup_packagig_design_mint_tea_moc_bilja_josif_pancic.jpg
// module id = 84
// module chunks = 0